import React from 'react';
import PropTypes from 'prop-types';
import idGenerator from 'react-id-generator';
import { useTranslations } from '@lang';
import StyledErrorMessage from './styled/StyledErrorMessage';

const Error = ({ error = null, meta = {}, isFieldError = true, className }) => {
  const { t } = useTranslations();

  const errors = [];
  if (typeof error === 'string') {
    errors.push({ errorMessage: error });
  } else if (Array.isArray(error)) {
    errors.push(...error);
  } else if (error) {
    errors.push(error);
  }
  if (meta && typeof meta.error === 'string') {
    errors.push({ errorMessage: meta.error });
  } else if (meta && Array.isArray(meta.error)) {
    errors.push(...meta.error);
  }

  // render redux-form error (only if touched) or custom error from props
  return errors.length > 0 && (meta.touched || error) ? (
    <StyledErrorMessage isFieldError={isFieldError} className={className}>
      {errors.map((err) =>
        err.code ? (
          <span key={idGenerator()}>{t(`error.${err.code}`, { ...err })}</span>
        ) : (
          <span key={idGenerator()}>{err.errorMessage}</span>
        )
      )}
    </StyledErrorMessage>
  ) : null;
};

Error.propTypes = {
  /** Custom error. */
  error: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string, PropTypes.array]),
  /** Redux form meta object */
  meta: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  }),
  isFieldError: PropTypes.bool,
};

export default Error;
